import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "gatsby-plugin-intl";
import { Button, Icon, Header } from "semantic-ui-react";
import { Block } from "./StyledComponent";
import HardLink from "./HardLink";
import { PICPICK_DISCOUNT, IS_BLACKFRIDAY } from "../constants";
// export const EventBanner = () => null

export const EventBanner = ({ intl, showButton, landing }, { isMobile }) => {
  if (intl.locale === "ko" || !PICPICK_DISCOUNT) {
    return null;
  }

  return (
    <Block textAlign="center" color={IS_BLACKFRIDAY ? "red" : "orange"}>
      <Header as="h1" textAlign="center" size="huge">
        <span className="color-white">
          {IS_BLACKFRIDAY
            ? "BLACK FRIDAY"
            : intl.formatMessage({ id: "text_limitedtimeoffer" })}{" "}
          -{" "}
        </span>
        <span className="color-white">UP TO 20% OFF</span>
      </Header>
      <p style={{ color: "white" }}>
        <Icon name="clock outline" />
        {intl.formatMessage({ id: "promotion_timeout" })}
      </p>
      {showButton && (
        <Button
          inverted
          color="white"
          icon="cart"
          size={isMobile ? "big" : "huge"}
          as={HardLink}
          name="buy"
          to="/buy"
          fluid={isMobile}
          style={{ margin: 5 }}
          content={intl.formatMessage({ id: "nav_buy" })}
        />
      )}
    </Block>
  );
};

// EventBannerBlackFriday
export const EventBannerBlackFriday = ({ intl, showButton }, { isMobile }) => {
  if (intl.locale === "ko" || !PICPICK_DISCOUNT) {
    return null;
  }

  return (
    <Block textAlign="center" color="yellow">
      <Header as="h1" textAlign="center" size="huge">
        <span className="black-friday">BLACK FRIDAY & CYBER MONDAY SALE</span> -{" "}
        <span className="color-red">UP TO 20% OFF</span>
      </Header>
      <p style={{ marginTop: "1em" }}>
        <Icon name="clock outline" color="orange" />
        {`Deal extended - Don't miss out before it's gone. Promo ends on Dec. 4th, 2022.`}
      </p>
      {showButton && (
        <Button
          color="orange"
          icon="cart"
          size={isMobile ? "big" : "huge"}
          as={HardLink}
          name="buy"
          to="/buy"
          fluid={isMobile}
          style={{ margin: 5 }}
          content={intl.formatMessage({ id: "nav_buy" })}
        />
      )}
    </Block>
  );
};

EventBanner.contextTypes = {
  isMobile: PropTypes.bool,
};

export default injectIntl(EventBanner);
